import { Badge } from "@/components/ui/badge";

export function CategoryCard({ category, manualReview, assessmentId, generatedAt }) {
  return (
    <section className="paper-card overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12">
        <div className="border-b border-border bg-gradient-deep p-8 text-primary-foreground lg:col-span-4 lg:border-b-0 lg:border-r">
          <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-primary-foreground/70">
            Provider category
          </p>
          <p className="mt-6 flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-sm border border-primary-foreground/20 bg-primary-foreground/10 font-display text-2xl font-medium">
              R
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-mono-label text-[10px] uppercase tracking-[0.18em] text-primary-foreground/60">
                Framework
              </span>
              <span className="font-display text-sm tracking-wide">R.E.A.D.Y. v0.1</span>
            </span>
          </p>
          <div className="mt-8 space-y-2">
            <p className="font-mono-label text-[10px] uppercase tracking-[0.18em] text-primary-foreground/60">
              Reference
            </p>
            <p className="font-mono-label text-sm tracking-wider">{assessmentId}</p>
          </div>
          <div className="mt-4 space-y-2">
            <p className="font-mono-label text-[10px] uppercase tracking-[0.18em] text-primary-foreground/60">
              Generated
            </p>
            <p className="text-sm">{generatedAt}</p>
          </div>
        </div>
        <div className="flex flex-col gap-4 p-8 lg:col-span-8">
          <div className="flex flex-wrap items-center gap-2">
            <Badge
              variant="outline"
              className="rounded-sm border-accent/40 bg-accent-soft px-2.5 py-1 font-mono-label text-[10px] uppercase tracking-[0.18em] text-accent"
            >
              {manualReview ? "Manual Review — Hold" : "Preliminary"}
            </Badge>
            <Badge
              variant="outline"
              className="rounded-sm border-border bg-card px-2.5 py-1 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground"
            >
              NDIS 0138 Readiness / R.E.A.D.Y.
            </Badge>
          </div>
          <h2 className="font-display text-2xl font-medium leading-tight text-foreground sm:text-3xl">
            {category.title}
          </h2>
          <p className="text-[15px] leading-relaxed text-muted-foreground">{category.summary}</p>
          <div className="mt-2 rounded-sm border border-border bg-muted/50 p-4 text-xs leading-relaxed text-muted-foreground">
            NDIS 0138 Readiness is a consultancy readiness tool only. It is not legal advice, an
            Approved Quality Auditor report, an official NDIS Commission tool, a registration
            guarantee, or a compliance certification.
          </div>
        </div>
      </div>
    </section>
  );
}
